import { BLAZE_BLOG_POSTS_HELP_CENTER_URL } from 'paths'
import Styles from './BlogPostLearnMoreLink.module.scss'

export const BlogPostLearnMoreLink = () => (
  <div className={Styles.root}>
    <a href={BLAZE_BLOG_POSTS_HELP_CENTER_URL} target="_blank" rel="noreferrer" className={Styles.link}>
      Click here
    </a>
    {' to learn more about blog post generation, including how we include external links.'}
  </div>
)
